module.exports = __webpack_public_path__ + "static/media/infoJumbo3.112197b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/aerolift/images/infoJumbo3.jpg
// module id = 532
// module chunks = 0